import { setThemeColorsProperty, getThemeColorsProperty } from '../../theme/defaultThemeOperators';
export const getSadColor = getThemeColorsProperty('sadColor');
export const getNeutralColor = getThemeColorsProperty('neutralColor');
export const getHappyColor = getThemeColorsProperty('happyColor');
export const setSadColor = setThemeColorsProperty('sadColor');
export const setNeutralColor = setThemeColorsProperty('neutralColor');
export const setHappyColor = setThemeColorsProperty('happyColor');